import $ from 'jquery'

onDomLoad(() => {
  if ($('[data-behaviour="sf-account-trend"]').length) {
    Silverfin.ViewComponents.Chart.AccountTrend.drawAll()
  }
})
